const config = require("../../env")();

import Network from "../network/network";
import { EntityTypeId } from "../util/EntityTypeId";
import Logger, { Loglevel } from "../util/Logger";

export default class AvatarService {
    private SERVICE_NAME = "AvatarService";
    private API_ROUTE = "Avatar";

    private readonly network: Network;
    private readonly logger: Logger;

    constructor(network: Network, logger: Logger) {
        this.network = network;
        this.logger = logger;
    }

    public getAvatar = async (id: number, entityTypeId: EntityTypeId): Promise<string> => {
        try {
            var isIE11 = !!window["MSInputMethodContext"] && !!(document as any).documentMode;
            if (isIE11) {
                //base64 by fetch for ie11 has different size (may encoding) and get interpreted as application/octet-stream, hack for ie use static icons
                return this.getPlaceholderAvatar(entityTypeId);
            } else {
                const avatar = await this.network.requestPublicApi(`${this.API_ROUTE}?id=${id}&typeId=${entityTypeId}&width=50&height=50&roundCorners=False`);
                return this.getDataURL(await avatar.blob());
            }
        } catch (e) {
            // A warning, whatever the reason: the message names the contact, so the relay would send an entry
            // of its own for every contact shown - the suppression window only holds back the same message.
            // A missing picture is an everyday case anyway, and a failing endpoint is in the backend log.
            this.logger.log(Loglevel.Warning, `Could not get avatar for id: ${id} with typeId: ${entityTypeId}`, e);
            // Never nothing: the multiselect chips write the answer into url("…") and the relation list into
            // src="…" unchecked, so an empty one renders as a broken image plus a request to the add-in host
            // for "undefined" - once per contact shown.
            return this.getPlaceholderAvatar(entityTypeId);
        }
    };

    private getPlaceholderAvatar = (entityTypeId: EntityTypeId): string => {
        if (entityTypeId === EntityTypeId.PersonEntity) {
            return `https://${config.ORPHY_URL}/content/images/buttonicons/empty_people.jpg`;
        } else if (entityTypeId === EntityTypeId.InstitutionEntity) {
            return `https://${config.ORPHY_URL}/content/images/buttonicons/empty_industry.jpg`;
        } else {
            return `https://${config.ORPHY_URL}/content/images/buttonicons/empty_task.jpg`;
        }
    };

    private getDataURL = (blob: Blob): Promise<string> => {
        return new Promise(res => {
            const r = new FileReader();
            r.onload = img => res(img.target.result as string);
            r.readAsDataURL(blob);
        });
    };
}
